/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiTagsIdMutationResponse, DeleteApiTagsIdPathParams, DeleteApiTagsId400, DeleteApiTagsId401, DeleteApiTagsId403, DeleteApiTagsId404, DeleteApiTagsId500 } from "../../types/DeleteApiTagsId.ts";
import { deleteApiTagsIdMutationResponseSchema } from "../../zod/TagSchemas/deleteApiTagsIdSchema.ts";

function getDeleteApiTagsIdUrl({ id }: { id: DeleteApiTagsIdPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/tags/${id}` as const }  
  return res
}

/**
 * @summary Удаление жанра по идентификатору
 * {@link /api/tags/:Id}
 */
export async function deleteApiTagsId({ id }: { id: DeleteApiTagsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiTagsIdMutationResponse, ResponseErrorConfig<DeleteApiTagsId400 | DeleteApiTagsId401 | DeleteApiTagsId403 | DeleteApiTagsId404 | DeleteApiTagsId500>, unknown>({ method : "DELETE", url : getDeleteApiTagsIdUrl({ id }).url.toString(), ... requestConfig })  
  return deleteApiTagsIdMutationResponseSchema.parse(res.data)
}